export default "__VITE_ASSET__452fb4df__"